import React, { useEffect, useState } from 'react'
import './styles.scss'
import CountUp from 'react-countup'

const f = new Intl.NumberFormat('de-CH')

interface Props {
  timeInRoom: number
  criticalDose: number
  result: number[]
  isMobile: boolean
}

export const Sticky = ({
  result,
  timeInRoom,
  criticalDose = 500,
  isMobile
}: Props) => {
  const [time, setTime] = useState(timeInRoom)
  useEffect(() => {
    setTime(timeInRoom)
  }, [timeInRoom])
  const isinfected = +timeInRoom >= result[1]
  const timeUntilCritical = result[1]
  const maxTime = 720
  const virusCount = +result[0].toFixed(0)
  const virusTime = +timeUntilCritical.toFixed(0)
  const text = isinfected ? (
    <>
      Une infection est <b>probable</b>.
    </>
  ) : (
    <>
      Une infection est <b>peu probable</b>.
    </>
  )
  console.log('timeUntilCritical', timeUntilCritical >= maxTime)
  return (
    <div className='Sticky'>
      <div className={isMobile ? '' : 'ui text container'}>
        <div className={'content ' + (isinfected ? 'inf' : '')}>
          <div className='text'>{text}</div>
          <div className='factwrapper'>
            <div className='fact'>
              <b>
                <CountUp
                  end={virusCount}
                  duration={1}
                  formattingFn={n => (n > 9999 ? f.format(n) : n + '')}
                  preserveValue
                />
              </b>
              <label>
                {' '}
                virus inhalés après {time} minutes{isMobile ? '.' : ''}
              </label>
            </div>
            <div className='fact'>
              <b>
                <CountUp
                  end={virusTime}
                  duration={1}
                  formattingFn={n => {
                    return timeUntilCritical >= maxTime
                      ? `plus de 12 heures`
                      : `${f.format(n)} minutes`
                  }}
                  preserveValue
                />
              </b>
              <label>
                {' '}
                dans la pièce jusqu’à l’atteinte de la dose critique de{' '}
                <b className='nobg'>
                  {f.format(criticalDose)} virus{isMobile ? '.' : ''}
                </b>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
